import { HeaderComponent } from '@aipb/gulliver/catalog/feature-header';
import { DetailItem } from '@aipb/gulliver/catalog/model';
import { SimpleCardComponent } from '@aipb/shared/ui/card';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'cat-compare-mobile',
  templateUrl: './compare-mobile.component.html',
  styleUrls: ['./compare-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, HeaderComponent, SimpleCardComponent, TranslocoModule]
})
export class CompareMobileComponent {
  @Input() first: DetailItem;
  @Input() second: DetailItem;

  @Output() action = new EventEmitter<DetailItem>();
}
